import React, { useState, useEffect } from "react";
import { FaArrowUp, FaRocket } from "react-icons/fa";

const AttractiveScrollButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Enhanced smooth scroll with easing animation
  const scrollToTop = () => {
    if (isScrolling) return; // Prevent multiple clicks
    
    setIsScrolling(true);
    
    const startPosition = window.pageYOffset;
    const startTime = performance.now();
    const duration = 1000; // 1 second duration
    
    // Easing function for smooth animation
    const easeInOutCubic = (t) => {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };
    
    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutCubic(progress);
      
      const newPosition = startPosition - (startPosition * easedProgress);
      window.scrollTo(0, newPosition);
      
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        setIsScrolling(false);
      }
    };
    
    requestAnimationFrame(animateScroll);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      {/* YOYO Gaming themed scroll button - matching chat button colors */}
      <div className="fixed bottom-3 right-5 z-50">
        <button
          onClick={scrollToTop}
          disabled={isScrolling}
          className={`
             group relative
             w-11 h-11 rounded-full
             bg-gradient-primary
             hover:opacity-90
             text-white
             transform transition-all duration-300
             hover:scale-110
             shadow-lg
             backdrop-blur-sm
             ${isScrolling ? 'animate-pulse scale-95' : ''}
             ${
               isVisible
                 ? "translate-y-0 opacity-100"
                 : "translate-y-16 opacity-0"
             }
           `}
          aria-label="YOYO scroll to top"
        >
          {/* Icon */}
          <div className="relative flex items-center justify-center h-full z-10">
            <FaArrowUp
              size={16}
              className={`transform transition-all duration-300 filter drop-shadow-sm ${
                isScrolling 
                  ? 'animate-bounce text-purple-200' 
                  : 'group-hover:-translate-y-0.5'
              }`}
            />
          </div>

          {/* Rotating circular scanning effect with YOYO gradient */}
          <div className="absolute inset-0 rounded-full overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div
              className="absolute inset-0 rounded-full"
              style={{
                background: `conic-gradient(from 0deg, transparent 0deg, rgba(126, 34, 206, 0.6) 20deg, rgba(67, 56, 202, 0.4) 40deg, transparent 60deg)`,
                animation: "spin 2s linear infinite",
              }}
            ></div>
          </div>

          {/* Gaming sparkle effect */}
          <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-300 rounded-full opacity-0 group-hover:opacity-100 animate-pulse"></div>
          <div className="absolute bottom-2 left-2 w-1 h-1 bg-indigo-300 rounded-full opacity-0 group-hover:opacity-100 animate-pulse delay-300"></div>
          
          {/* Scroll progress indicator */}
          {isScrolling && (
            <div className="absolute -inset-1 rounded-full border-2 border-purple-400/60 animate-ping"></div>
          )}
        </button>
      </div>
      {/* <div className="fixed bottom-3 right-5 z-50">
         <button
           onClick={scrollToTop}
           className={`
             group relative
             w-11 h-11 rounded-full
             bg-gradient-to-br from-purple-600 via-purple-500 to-indigo-600
             hover:from-purple-500 hover:via-purple-400 hover:to-indigo-500
             text-white hover:text-purple-100
             transform transition-all duration-300
             hover:scale-110 hover:-translate-y-1
             border-2 border-purple-400/50 hover:border-purple-300
             shadow-lg shadow-purple-500/25 hover:shadow-purple-400/50
             backdrop-blur-sm
             ${isVisible ? "translate-y-0 opacity-100" : "translate-y-16 opacity-0"}
           `}
           style={{
             boxShadow: "0 0 25px rgba(126, 34, 206, 0.4), inset 0 0 20px rgba(126, 34, 206, 0.1)",
           }}
           aria-label="YOYO scroll to top"
         >
           
           <div className="absolute inset-0 rounded-full border-2 border-purple-400/0 group-hover:border-purple-400/60 transition-all duration-300 animate-pulse"></div>
           <div className="absolute -inset-1 rounded-full border border-purple-400/0 group-hover:border-purple-400/40 transition-all duration-300"></div>
           <div className="absolute -inset-2 rounded-full border border-indigo-400/0 group-hover:border-indigo-400/30 transition-all duration-500"></div>
           <div className="absolute -inset-3 rounded-full border border-purple-500/0 group-hover:border-purple-500/20 transition-all duration-700"></div>


           <div className="relative flex items-center justify-center h-full z-10">
             <FaArrowUp
               size={18}
               className="transform transition-all duration-300 group-hover:-translate-y-0.5 filter drop-shadow-sm"
             />
           </div>

           
           <div className="absolute inset-0 rounded-full overflow-hidden opacity-0 group-hover:opacity-100 transition-opacity duration-300">
             <div
               className="absolute inset-0 rounded-full"
               style={{
                 background: `conic-gradient(from 0deg, transparent 0deg, rgba(126, 34, 206, 0.6) 20deg, rgba(67, 56, 202, 0.4) 40deg, transparent 60deg)`,
                 animation: "spin 2s linear infinite",
               }}
             ></div>
           </div>

         
           <div className="absolute inset-0 rounded-full border-2 border-purple-400/0 group-hover:border-purple-400/80 group-hover:animate-ping transition-all duration-300"></div>

           
           <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-purple-300 rounded-full opacity-0 group-hover:opacity-100 animate-pulse"></div>
           <div className="absolute bottom-2 left-2 w-1 h-1 bg-indigo-300 rounded-full opacity-0 group-hover:opacity-100 animate-pulse delay-300"></div>
         </button>
       </div> */}
    </>
  );
};

export default AttractiveScrollButton;
